app.controller(
    'DistrictCorrectionController', ['$scope', '$rootScope', '$http', '$stateParams', '$timeout', 'toastr', '$document', 'Configuration', 'DistrictService', 'SideBarService', '$sce', '$translate', 'HelperService', '$window',  DistrictCorrectionController]
);

function DistrictCorrectionController($scope, $rootScope, $http, $stateParams, $timeout, toastr, $document, Configuration, DistrictService, SideBarService, $sce, $translate, HelperService,$window) {
    var vm = this;
    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $rootScope.CurrentZoneId = vm.ParamZoneId;

    $translate.use($rootScope.LangForInterface);

    $scope.quartier = {};
    $scope.edit = {};

    vm.ActiveDescription = {};
    vm.ActiveDescriptionId = 0;

    vm.quartier = {
        DescriptionPositionList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
    };
    vm.ActiveDescriptionVm =
        {
            Clients: [{ "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }],
            QualificationList: [{ "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }],
            DescriptionNewPositionText: '1'
        };
    vm.ActiveDescriptionVmOrigin = angular.copy(vm.ActiveDescriptionVm);

    vm.StatusList4WorkflowDescription = ['', '', '', '', '', ''];


    //Get Single 
    var promiseGetSingle = DistrictService.getDistrict($stateParams.id, $scope.CurrentLang, "", $stateParams.index, $stateParams.sortKey, $stateParams.reverse);
    promiseGetSingle.then(function (t) {
        var res = t.data;
        vm.quartier = res;
        vm.quartierOrigin = angular.copy(res);

        if (vm.quartier.DescriptionList.length > 0) {
            vm.ActiveDescriptionId = 0;
            vm.ActiveDescription = vm.quartier.DescriptionList[vm.ActiveDescriptionId];
            vm.GetDescriptionVm();
        }


        $rootScope.PlaceList = res.PlaceList;
        $rootScope.CurrentObjectId = res.CurrentDisctrict.DistrictId;
        $rootScope.CurrentPageType = $rootScope.EnumLinkType.District;
        $rootScope.CurrentObjectStatus = res.CurrentDistrictStatus;
        $rootScope.SideBar.CurrentObjectStatus = res.CurrentDistrictStatus;
        $rootScope.Comments = res.CommentList;
        $rootScope.SideBar = res.SideBar;
        $rootScope.Clients = res.ClientList;
        $rootScope.ClassificationList = res.ClassificationList;

        vm.StatusList4WorkflowDescription = angular.copy($rootScope.StatusList4WorkflowDescription);
        //$scope.ChangeZoneById(vm.ParamZoneId);

        

    });

    $scope.UpdateDistrict = function UpdateDistrict() {
        DistrictService.UpdateDistrict(vm.quartier);
    };
    vm.UpdateDescription = function () {
        if (vm.ActiveDescriptionVm.Description != undefined) {
            HelperService.UpdateDescription(vm.quartier.DescriptionList[vm.ActiveDescriptionId])
                .then(function (data) {
                });
        }
    }
    vm.OpenInOtherLang = function (lang) {
        $window.location.href = $rootScope.interfaceSubFolder + '/#!/correction/district?id=' + vm.quartier.District.DistrictId + "&lang=" + lang + "&index=" + $stateParams.index + "&sortKey=" + $stateParams.sortKey + "&reverse=" + $stateParams.reverse + "&z=" + $stateParams.z;
    }
    vm.GetDescriptionVm = function () {
        HelperService.GetDescriptionVmWithSort(vm.quartier.DescriptionList[vm.ActiveDescriptionId].DescriptionId, vm.quartier.District.DistrictId, $rootScope.EnumLinkType.District, 0, $scope.CurrentLang)
            .then(function (desc) {
                vm.ActiveDescriptionVm = desc;
                vm.ActiveDescriptionVmOrigin = angular.copy(vm.ActiveDescriptionVm);
            });
    }

    vm.PreviousDesc = function () {
        if (vm.quartier.DescriptionList.length > 0 && vm.ActiveDescriptionId > 0) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId - 1;
            vm.GetDescriptionVm();
        }
    }

    vm.NextDesc = function () {
        if (vm.quartier.DescriptionList.length > 0 && vm.ActiveDescriptionId < vm.quartier.DescriptionList.length - 1) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId + 1;
            vm.GetDescriptionVm();
        }
    }

    vm.UpdateDescriptionStatus = function () {
        if (vm.ActiveDescriptionVm.Description != undefined) {
            HelperService.UpdateDescriptionStatus(vm.ActiveDescriptionVm.Description.DescriptionId, $scope.CurrentLang, vm.ActiveDescriptionVm.DescriptionStatus);
        }
    }

    vm.UpdateDescriptionPosition = function () {
        if (vm.ActiveDescriptionVm.Description != undefined) {
            HelperService.UpdateDescriptionPosition(vm.quartier.District.DistrcitId, vm.ActiveDescriptionVm.Description.DescriptionId, vm.ActiveDescriptionVm.DescriptionCurrentPositionText, vm.ActiveDescriptionVm.DescriptionNewPositionText, $rootScope.EnumLinkType.District);
        }
    }



    $rootScope.refreshHistory = function refreshHistory() {
        var lastelement = $rootScope.SideBar.HistoryList == null ? null : $rootScope.SideBar.HistoryList.shift();
        promiseRefreshHistory = SideBarService.RefreshHistory($rootScope.CurrentObjectId, $stateParams.lang, "District", (lastelement == null ? 0 : lastelement.ChangeLogId));
        promiseRefreshHistory
            .then(
                  function success(data) {
                      $rootScope.SideBar.HistoryList = $rootScope.returnNewHistory.concat($rootScope.SideBar.HistoryList);

                  },
                function error(data) {
                });
    };

    // SideBar method

    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {

        SideBarService.UpdateObjectStatus(status, objectId, $scope.CurrentLang, 16, function (response) {

            if (response.success) {

                console.log("ok: ");

            } else {
                console.log("error: ");
            }
        });
    };

    $rootScope.AddComment = function AddComment(CurrentObjectId) {

        promiseAddComment = SideBarService.AddComment(vm.quartier.SideBar.CommentEdit, vm.quartier.CurrentDisctrict.DistrictId, $scope.CurrentLang, 16);

        promiseAddComment
            .then(
                function success(data) {
                    $rootScope.Comments = $rootScope.returnNewComments;
                    $rootScope.SideBar.CommentEdit.Comment = '';
                },
                function error(data) {
                }
            );
    };

    $rootScope.SaveDiffuseur = function SaveDiffuseur() {

        promiseAddComment = DistrictService.SaveDiffuseur(vm.quartier.ClientList, vm.quartier.CurrentDisctrict.DistrictId, $scope.CurrentLang, 16);
    };

    $rootScope.SaveAdressesAssociees = function SaveAdressesAssociees() {

        promiseAddComment = DistrictService.SaveAdressesAssociees(vm.quartier.PlaceList, vm.quartier.CurrentDisctrict.DistrictId, $scope.CurrentLang, 16);
    };

    $rootScope.SaveClassification = function SaveClassification() {

        promiseAddComment = DistrictService.SaveClassification(vm.quartier.ClassificationList, vm.quartier.CurrentDisctrict.DistrictId, $scope.CurrentLang, 16);
    };



    $scope.dropdownDescIsOpen = false;

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };

    $scope.updateFieldTags = function () {
        $scope.$emit('updateFieldTags');
    };

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareInfoByDefaultMail('emailShareDistrictPracticalInfo', $translate.instant('emailShareDistrictPracticalInfo').replaceAll('&amp;', '&'), vm.quartier);
    }

    $rootScope.shareFicheComplete = function () {
        $rootScope.shareInfoPratique();
    }
};